import PropTypes from 'prop-types';
import { Row } from 'antd';
import './CardLabel.scss';

export const CardLabel = ({ nameLabel }) => {
  return (
    <Row className="card-label-home">
      <span className="card-label-span-home">{nameLabel}</span>
    </Row>
  );
};

CardLabel.propTypes = {
  nameLabel: PropTypes.string.isRequired
};
